import firebase from 'firebase/compat/app';

import agentKbRootDoc from './agentKbRootDoc';

const converter = {
  toFirestore(item: AgentKb.Meta): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): AgentKb.Meta {
    return snapshot.data(options) as AgentKb.Meta;
  },
};

// KB metadata: agentKb/main (or accounts/{accountId}/agentKb/main). Holds the
// live pointer and the last-imported version. Read-only in the client — every
// write goes through the insightsAgentKb endpoint, which owns the revision and
// publish invariants.
const getAgentKbRef = ({
  scope,
  accountId,
  db,
}: {
  scope: AgentKb.ScopeName;
  accountId?: string;
  db?: firebase.firestore.Firestore;
}) => agentKbRootDoc({ scope, accountId, db }).withConverter(converter);

export default getAgentKbRef;
